module.exports = __webpack_public_path__ + "static/sharepoint-2b0144a85ee263c155fbaad0c6e39b83.png";